/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import AutomaticSetting from "./AutomaticSetting";
import PassivityScrapingModal from "./Component/PassivityScrapingModal";
import ScrapingHistory from "./ScrapingHistory";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

import { toast } from "../../../utils/toast";

const ManagerFinancial = (props) => {
  const { scrapingRuns, permissions } = useSelector((store) => ({
    scrapingRuns: store.ScrapingRuns,
    permissions: store.Profile.permissions
  }));
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('auto-scrapping');
  const [isOpen, setIsOpen] = useState(false);
  const [targetPermission, setTargetPermission] = useState(null);
  const [runReload, setRunReload] = useState(0);
  
  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FINANCE_SCRAPING')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "FINANCE_SCRAPING")
      }
    }
  }, [permissions])

  const _setActiveTab = (value) => {
    history.push(`/manager/financial?tab=${value}`);
  };

  const tabList = [
    { label: "자동수집 설정", action: _setActiveTab, value: 'auto-scrapping' },
    { label: "수집이력", action: _setActiveTab, value: 'scraping-history' },
  ];

  const reloadHandler = async () => {
    setRunReload(runReload+1)
  }

  const headerButtons = [
    {
      isHide: activeTab === 'auto-scrapping',
      label: "새로고침",
      color: 'green',
      action: () => {
        //window.location.reload()
        setRunReload(runReload+1)
      },
    },
    {
      isHide: activeTab === 'auto-scrapping',
      label: "전체 수동 스크래핑",
      color: scrapingRuns.runHometax || scrapingRuns.runCardSales || scrapingRuns.runCard || scrapingRuns.runCcd || scrapingRuns.runPbk || scrapingRuns.runCbk ? "gray-line" : "green",
      action: () => {
        if (scrapingRuns.runHometax || scrapingRuns.runCardSales || scrapingRuns.runCard || scrapingRuns.runCcd || scrapingRuns.runPbk || scrapingRuns.runCbk) {
          toast.info("스크래핑중입니다. 완료후 시도하세요.")
          return
        } else {
          setIsOpen(true)
        }
      },
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader
          title={"금융 정보 자동 수집"}
          activeTab={activeTab}
          tabList={tabList}
          buttons={targetPermission.level > 1 ? headerButtons : []}
        />
        {activeTab === "auto-scrapping" && <AutomaticSetting permission={targetPermission} />}
        {activeTab === "scraping-history" && <ScrapingHistory permission={targetPermission} runReload={runReload} />}
        {isOpen && <PassivityScrapingModal isOpen={isOpen} setIsOpen={setIsOpen} type="all" reload={reloadHandler} />}
      </>
    ));
};

export default ManagerFinancial;
